
import React from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { FormInputTextField } from '../fields/FormInputTextField';
import { PostingRecencySelect } from './advanced-options/PostingRecencySelect';
import { JobSearchFormData } from '../JobSearchFormSchema';

interface BasicSearchFieldsProps {
  control: Control<JobSearchFormData>;
  errors: FieldErrors<JobSearchFormData>;
  isLoading: boolean;
}

export const BasicSearchFields: React.FC<BasicSearchFieldsProps> = ({ control, errors, isLoading }) => {
  return (
    <>
      <FormInputTextField
        name="industry"
        control={control}
        label="Industry"
        placeholder="e.g., Software, Manufacturing, E-commerce"
        error={errors.industry}
        disabled={isLoading}
      />
      <FormInputTextField
        name="jobRole"
        control={control}
        label="Target Company Profile / Contact Role"
        placeholder="e.g., Mid-size SaaS, Head of Talent Acquisition"
        error={errors.jobRole}
        disabled={isLoading}
      />
      <FormInputTextField
        name="geography"
        control={control}
        label="Geography / Location"
        placeholder="e.g., New York, DACH Region, Remote-first"
        error={errors.geography}
        disabled={isLoading}
      />
      <PostingRecencySelect
        control={control}
        isLoading={isLoading}
      />
    </>
  );
};
